module.exports = __webpack_public_path__ + "img/30_42.921c5df2.png";